<!-- Mobile Overlay -->
@if (mobileOpen()) {
<div class="fixed inset-0 bg-black/50 z-40 lg:hidden" (click)="closeMobile()" aria-hidden="true"></div>
}

<aside
  class="bg-surface relative border-r h-screen border-border-subtle flex flex-col transition-all duration-300 ease-in-out fixed lg:static inset-y-0 left-0 z-50 lg:z-auto w-64 max-w-[85vw] lg:max-w-none"
  [class.lg:w-64]="!effectiveCollapsed()" [class.lg:w-20]="effectiveCollapsed()"
  [class.-translate-x-full]="!mobileOpen()" [class.lg:translate-x-0]="true" [class.invisible]="!mobileOpen()"
  [class.lg:visible]="true" [attr.aria-label]="'Sidebar navigation'" [attr.aria-hidden]="!mobileOpen()">
  <!-- Logo/Brand Section -->
  <div class="flex flex-col gap-2 p-4 relative">
    @if (!effectiveCollapsed() || mobileOpen()) {
    <div class="flex flex-col items-center gap-2">
      <div class="flex items-center justify-center">
        <picture>
          <source srcset="../../../../assets/images/logo.svg" type="image/webp" />
          <img src="../../../../assets/images/logo.svg" alt="Logo" />
        </picture>
      </div>
      <div class="relative w-full">
        <p class="text-xs text-text-muted text-center">Powered By DelMonte</p>
        <button (click)="toggleCollapse()"
          class="absolute -right-8 -top-18 -translate-y-1/2 flex items-center justify-center rounded-full w-9 h-9 border border-border-subtle bg-surface text-text-strong shadow-sm hover:bg-bg transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-1"
          [attr.aria-label]="effectiveCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
          [attr.aria-expanded]="!effectiveCollapsed()">
          <hugeicons-icon [icon]="MenuCollapseIcon" [size]="18" color="currentColor"
            [strokeWidth]="1.5"></hugeicons-icon>
        </button>
      </div>
    </div>
    } @else {
    <div class="relative flex flex-col items-center gap-2 min-h-[4.5rem]">
      <div class="w-10 h-10 flex items-center justify-center mx-auto">
        <picture>
          <source srcset="../../../../assets/images/logo.svg" type="image/webp" />
          <img src="../../../../assets/images/logo.svg" alt="Logo" />
        </picture>
      </div>
      <button (click)="toggleCollapse()"
        class="absolute rotate-180 -right-8 top-2/2 -translate-y-1/2 flex items-center justify-center rounded-full w-9 h-9 border border-border-subtle bg-surface text-text-strong shadow-sm hover:bg-bg transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-1"
        [attr.aria-label]="effectiveCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-expanded]="!effectiveCollapsed()">
        <hugeicons-icon [icon]="MenuCollapseIcon" [size]="18" color="currentColor" [strokeWidth]="1.5"
          class="rotate-180"></hugeicons-icon>
      </button>
    </div>
    }
  </div>

  <!-- Navigation Menu -->
  <nav class="flex-1 overflow-y-auto py-4 px-2  min-h-screen" role="navigation" aria-label="Main navigation">
    @for (item of menuItems(); track item.route) {
    <app-sidebar-item [label]="item.label" [route]="item.route" [icon]="item.icon ?? null"
      [hugeIcon]="item.hugeIcon ?? null" [collapsed]="effectiveCollapsed() && !mobileOpen()" />
    }
  </nav>

</aside>